<template>
    <rkm-form ref="Form">
        <rkm-row class="flex-nowrap">
            <rkm-col class="flex-grow-1">
                <rkm-form-input-autocomplete
                    :searchFields="localForm.autocompleteFields.ocupacao"
                    :repository="repositories.ocupacao"
                    v-model="cbo.ocupacao"
                    textField="nome"
                    label="CBO"
                    uppercase
                />
            </rkm-col>

            <rkm-col class="flex-grow-0 text-nowrap">
                <rkm-button
                    :label="false"
                    color="primary"
                    @click.stop="$refs.Form.validate(add)"
                >
                    Incluir
                </rkm-button>

                <rkm-button
                    :label="false"
                    color="danger"
                    @click.stop="resetForm"
                >
                    Limpar
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    created() {

        this.repositories = {
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
        }
    },
    data: () => ({
        localForm: {
            autocompleteFields: {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            },
        },
        cbo: {
            id: null,
            ocupacaoNome: null,
            ocupacaoId: null
        },
    }),
    methods: {
        add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        const cbo = this.clone(this.cbo)

                            if (this.hasOcupacaoParametrizada(cbo.ocupacao.id)) {

                                    this.resetForm()

                                    this.showValidationNotification("Já existe um registro com essa ocupação.")
                                    return
                            }

                        this.cbo.id = this.uniqueId('cbo' + new Date().getTime())

                        const param = {
                            id: this.cbo.id,
                            nome: cbo.ocupacao.nome,
                            ocupacaoId: cbo.ocupacao.id,
                        }

                        this.data.model.ocupacoes.push(param)

                        this.resetForm()
                })
        },
        hasOcupacaoParametrizada(ocupacao) {

            return this.data.model.ocupacoes.find(cbo => cbo.ocupacaoId === ocupacao)
        },
        resetForm() {

            this.cbo.ocupacao = null
            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
    },
    mixins: [ repository, object ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>